import appConfig from './apiConfig';

export const saveStudyApi =(studyData)=>{
let data =  JSON.stringify(studyData);
const headers = Object.assign({'content-type':"application/json",
                               'accept':'*/*'});
const request= new Request( appConfig.siteURL+'createStudy', {
  method : "POST",
  headers : headers,
  body : data
});

return fetch(request).then(response => {
    return  response.json().then(studyDataResponse => {
      return studyDataResponse;
    });
  }).catch(error => {
   return error;
 });
}


export const fetchAllStudyApi =()=>{
  
  const headers = Object.assign({'content-type':"application/json",
                                 'accept':'*/*'});
  const request= new Request( appConfig.siteURL+'getAllStudy', {
    method : "GET",
    headers : headers
  });
  
  return fetch(request).then(response => {
      return  response.json().then(studyDataResponse => {
        return studyDataResponse;
      });
    }).catch(error => {
     return error;
   });
  }

  export const updateStudyApi =(studyData)=>{
    let data =  JSON.stringify(studyData);
    const headers = Object.assign({'content-type':"application/json",
                                   'accept':'*/*'});
    const request= new Request( appConfig.siteURL+'updateStudy', {
      method : "POST",
      headers : headers,
      body : data
    });
    
    return fetch(request).then(response => {
        return  response.json().then(studyDataResponse => {
          return studyDataResponse;
        });
      }).catch(error => {
       return error;
     });
    }


    export const getViewInvitesApi =(studyData)=>{
      const headers = Object.assign({'content-type':"application/json",
                                     'accept':'*/*'});
      const request= new Request( appConfig.siteURL+'getViewInvites/'+studyData._id, {
        method : "GET",
        headers : headers,
       
      });
      
      return fetch(request).then(response => {
          return  response.json().then(invitesDataResponse => {
            return invitesDataResponse;
          });
        }).catch(error => {
         return error;
       });
      }


// WEBPACK FOOTER //
// ./src/api/studyApi.js